import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import TeaserInfo from '../../TeaserInfo'
import { TeaserProps, BasicTeaserType, TaboolaRegionItem } from '../TeaserInterface'
import BasicText from '../../Theme/Fonts/BasicText'
import LinkProps from '../../Link/LinkProps'
import VideoLabelProps from '../../BaseComponents/Labels/Video/VideoLabelProps'
import BigTeaserImage from './Image'

export type HorizontalBigTeaserProps = BasicTeaserType &
    TeaserProps &
    TaboolaRegionItem &
    LinkProps &
    VideoLabelProps

const HorizontalBigTeaser = ({
    tag,
    headlineText,
    labels,
    onShare,
    onPress,
    href,
    published,
    mainImageUrl,
    mainImageAlt,
    type,
    videoDuration,
    abstract,
    testID,
    headlineNumberOfLines = 3,
    webTBRegionItem,
    backgroundColor = 'pearl',
    textColor = 'onyx',
    innerRef,
    webRel,
    teaserIcon,
}: HorizontalBigTeaserProps): ReactElement => {
    return (
        <Touchable
            onPress={onPress}
            href={href}
            testID={testID}
            webTBRegionItem={webTBRegionItem}
            webRel={webRel}
        >
            <Grid ref={innerRef} noExpand backgroundColor={backgroundColor} horizontal>
                <Grid noExpand width="66%">
                    <BigTeaserImage
                        labels={labels}
                        type={type}
                        imageUrl={mainImageUrl}
                        alt={mainImageAlt}
                        videoDuration={videoDuration}
                        teaserIcon={teaserIcon}
                    />
                </Grid>
                <Grid marginLeft={6} width="34%">
                    <Grid minHeight={0}>
                        <BasicText
                            fontSize={['FS18', 'FS18', 'FS18', 'FS22']}
                            lineHeight="LH24"
                            bold
                            numberOfLines={headlineNumberOfLines}
                            color={textColor}
                            className={webTBRegionItem === '' ? 's1-taboola-title' : undefined}
                        >
                            {headlineText}
                        </BasicText>
                        {abstract ? (
                            <Grid noExpand marginTop={3}>
                                <BasicText
                                    color="keshi-3"
                                    fontSize={['FS15', 'FS15', 'FS15', 'FS18']}
                                    lineHeight="LH20"
                                    numberOfLines={7}
                                >
                                    {abstract}
                                </BasicText>
                            </Grid>
                        ) : null}
                    </Grid>
                    <Grid noExpand flexShrink={0}>
                        <TeaserInfo
                            testID={`${testID}_teaserInfo`}
                            imageUrl={tag?.imageUrl}
                            alt={tag?.imageAlt}
                            name={tag?.name}
                            published={published}
                            onShare={onShare}
                            tintColor={tag?.imageTintColor}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default HorizontalBigTeaser
